import { useNavigate, useParams } from 'react-router-dom';
import { SmartMenuOnboarding } from '@components/v4/onboarding/SmartMenuOnboarding';
import { usePartnerAuth } from '../PartnerAuthContext';
import { useDraftSession } from '../useDraftSession';
import { Button, Card, ErrorNote, Muted, PageShell, Title } from '../ui';

// Reusa el smart menu sobre el draft. useDraftSession deja el JWT-draft en localStorage como TOKEN
// DE COMERCIO (token + id_commerce) — el interceptor de axiosInstance lo usa para los POST del smart
// menu a los endpoints del panel (/v1/categoria, etc.). Se limpia/restaura al desmontar.
const PartnerDraftMenu = () => {
  const { id } = useParams<{ id: string }>();
  const { token } = usePartnerAuth();
  const navigate = useNavigate();
  const { ready, error } = useDraftSession(token, id);

  const onComplete = () => navigate('/partner');

  if (error) {
    return (
      <PageShell narrow>
        <Card>
          <Title>Menu del borrador</Title>
          <ErrorNote>{error}</ErrorNote>
          <Button variant="secondary" onClick={() => navigate('/partner')} style={{ marginTop: 14 }}>
            Volver al portal
          </Button>
        </Card>
      </PageShell>
    );
  }

  if (!ready) {
    return (
      <PageShell narrow>
        <Card>
          <Title>Preparando el menu...</Title>
          <Muted>Abriendo la sesion del borrador.</Muted>
        </Card>
      </PageShell>
    );
  }

  return <SmartMenuOnboarding skippable onComplete={onComplete} trackingSource="cargar_menu" />;
};

export default PartnerDraftMenu;
